import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid, FormControl, FormLabel, FormGroup, Checkbox,
} from '@mui/material';
import 'react-day-picker/lib/style.css';
import DateRangeFilterSingle from './date-range-filter-single';

function DateRangeFilter({
  name, afterDate, beforeDate, onChangeAfter, onChangeBefore, onClear,
}) {
  const [selectorChecked, setSelectorChecked] = useState(
    beforeDate !== undefined || afterDate !== undefined,
  );

  const changeChecked = () => {
    if (selectorChecked) {
      onClear();
    }
    setSelectorChecked(!selectorChecked);
  };

  return (
    <FormControl>
      <Grid container>
        <Grid
          item
          xs={12}
        >
          <Checkbox
            checked={selectorChecked}
            onChange={() => changeChecked()}
          />
          <FormLabel>{name}</FormLabel>
        </Grid>
      </Grid>
      <FormGroup>
        {selectorChecked && (
          <Grid container>
            <Grid
              item
              xs={4}
            >
              <DateRangeFilterSingle
                label="From"
                date={afterDate}
                onChange={onChangeAfter}
              />
            </Grid>
            <Grid
              item
              xs={4}
            >
              <DateRangeFilterSingle
                label="To"
                date={beforeDate}
                onChange={onChangeBefore}
              />
            </Grid>
          </Grid>
        )}
      </FormGroup>
    </FormControl>
  );
}

DateRangeFilter.propTypes = {
  onChangeBefore: PropTypes.func,
  onChangeAfter: PropTypes.func,
  onClear: PropTypes.func,
  name: PropTypes.string,
  beforeDate: PropTypes.instanceOf(Date),
  afterDate: PropTypes.instanceOf(Date),
};

DateRangeFilter.defaultProps = {
  onChangeBefore: () => {},
  onChangeAfter: () => {},
  onClear: () => {},
  name: '',
  beforeDate: undefined,
  afterDate: undefined,
};

export default DateRangeFilter;
